export default __webpack_public_path__ + "static/media/newsletter.8d324888.pdf";